/**
* Floating chat button component
*/

import ChatBubbleOutlineIcon from '@mui/icons-material/ChatBubbleOutline'
import CloseIcon from '@mui/icons-material/Close'
import type { ThemePalette } from '../utils/themeUtils'
import { BADGE_ANIMATION_CSS } from '../constants'

interface ChatButtonProps {
    isOpen: boolean
    onClick: () => void
    palette: ThemePalette
    logoUrl?: string
    unreadCount: number
}

export function ChatButton({ isOpen, onClick, palette, logoUrl, unreadCount }: ChatButtonProps) {
    const showBadge = !isOpen && unreadCount > 0
    const badgeText = unreadCount > 9 ? '9+' : String(unreadCount)

    return (
        <>
        {showBadge && <style>{BADGE_ANIMATION_CSS}</style>}
        <button
        type="button"
        onClick={onClick}
        style={{
            position: 'relative',
            width: '60px',
            height: '60px',
            borderRadius: '999px',
            border: 'none',
            cursor: 'pointer',
            boxShadow: '0 18px 30px rgba(99,102,241,0.35)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            background: palette.gradient,
            color: '#ffffff',
            transition: 'transform 0.2s ease',
        }}
        aria-expanded={isOpen}
        aria-label={isOpen ? 'Close chat widget' : `Open chat widget${unreadCount > 0 ? `, ${unreadCount} unread messages` : ''}`}
        >
        <div style={{ width: '24px', height: '24px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        {isOpen ? (
            <CloseIcon style={{ width: '100%', height: '100%' }} />
        ) : logoUrl ? (
            <img
            src={logoUrl}
            alt="Logo"
            style={{ width: '100%', height: '100%', objectFit: 'contain', borderRadius: '4px' }}
            />
        ) : (
            <ChatBubbleOutlineIcon style={{ width: '100%', height: '100%' }} />
        )}
        </div>

        {showBadge && (
            <span
            style={{
                position: 'absolute',
                top: '-4px',
                right: '-4px',
                minWidth: '20px',
                height: '20px',
                borderRadius: '10px',
                background: '#EF4444',
                color: '#ffffff',
                fontSize: '11px',
                fontWeight: 700,
                lineHeight: '20px',
                textAlign: 'center',
                padding: '0 5px',
                boxSizing: 'border-box',
                boxShadow: '0 2px 6px rgba(0,0,0,0.25)',
                animation: 'badge-pop-in 0.3s ease-out',
            }}
            aria-hidden="true"
            >
            {badgeText}
            </span>
        )}
        </button>
        </>
    )
}
